var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pa-0 footer-class", attrs: { fluid: "" } },
    [!_vm.isCheckout ? _c("links") : _vm._e(), _c("footer-address")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }